import React, { useEffect, useState } from "react";
import "./DrawerNavigator.css";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import logo from "../assets/images/LOGO LAWNET WHITE.png";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { FaBars } from "react-icons/fa";
import { PiUserCircleThin } from "react-icons/pi";
import { TbTriangleFilled } from "react-icons/tb";
import { TbTriangleInvertedFilled } from "react-icons/tb";
import Cookies from "js-cookie";
import Banner from "../components/Banner2";
import api from "../services/baseUrl";
const DrawerNavigator = ({ children }) => {
  const [openDrawer, setOpenDrawer] = useState(true);
  const [openMenu, setOpenMenu] = useState(null);
  const navigate = useNavigate();
  const toggle = () => {
    setOpenDrawer(!openDrawer);
  };
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  console.log("1234");
  console.log(cookie);
  const user = JSON.parse(cookie).user;
  const packageModel = JSON.parse(cookie).packageModel;
  const [openDialog, setOpenDialog] = useState(false);
  const [resources, setResources] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchResources = async () => {
      const response = await api.get("/resources");
      setResources(response.data);
    };
    fetchResources();
  }, [location.pathname]);

  const showBanner =
    !location.pathname.includes("/law-library/document") &&
    !location.pathname.includes("/user-profile");
  const toggleSubMenu = (menuName) => {
    if (menuItem.find((item) => item.name === menuName)?.submenu) {
      setOpenMenu((prev) => (prev === menuName ? null : menuName));
    } else {
      setOpenMenu(null);
    }
  };

  const handleLogout = async () => {
    try {
      const logout = await api.post("/api/logout");
      Cookies.remove("user", { secure: true, sameSite: "Strict" });
      Cookies.remove("token", { secure: true, sameSite: "Strict" });

      sessionStorage.removeItem("user");
      sessionStorage.removeItem("token");
      if (logout.status === 200) {
        Cookies.remove("user", { secure: true, sameSite: "Strict" });
        Cookies.remove("token", { secure: true, sameSite: "Strict" });

        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        navigate("/logout-success");
      }
    } catch(error) {
      navigate("/login");
    }
  };

  const menuItem = [
    {
      path: "/dashboard",
      name: "DASHBOARD",
    },
    {
      path: "/law-library",
      name: "LAW LIBRARY",
    },
    {
      name: "E-GAZETTE",
      submenu:
        packageModel.packageCode === 1 || packageModel.packageCode === "1"
          ? [
              { path: "e-gazette/federal-&-states", name: "Federal & State Gazettes" },
              {
                path: "e-gazette/local-municipal-council",
                name: "Local Authority By-Laws",
              },
              { path: "e-gazette/land-laws", name: "Land Laws" },
              {
                path: "e-gazette/medal-honours",
                name: "Medal Honours (Datukships and Sustainability Awards)",
              },
            ]
          : [{ path: "e-gazette/federal-&-states", name: "Federal & States" }],
    },
    {
      name: "CASE LAW",
      submenu: [
        { path: "/case-law?courtType=1", name: "Civil and Criminal" },
        { path: "/case-law?courtType=2", name: "Syariah" },
        { path: "/case-law?courtType=3", name: "Industrial Relations" },
      ],
    },
    {
      name: "SAFETY, HEALTH & ENVIRONMENT",
      path: "/safety-health-environment",
    },
    {
      name: "RESOURCE CENTRE",
      submenu: resources,
      // submenu: [
      //   {
      //     path: "/resource-centre/parliament-of-malaysia-hansard",
      //     name: "Parliament of Malaysia Hansard",
      //   },
      //   // {
      //   //   path: "/resource-centre/comissioner-of-oaths",
      //   //   name: "Comissioner of Oaths",
      //   // },
      //   // { path: "/resource-centre/courts", name: "Courts" },
      //   // {
      //   //   path: "/resource-centre/practice-direction",
      //   //   name: "Practice Direction",
      //   // },
      // ],
    },
    // {
    //   path: "/index",
    //   name: "INDEX",
    // },
    {
      path: "/latin-dictionary",
      name: "LATIN DICTIONARY",
    },
    {
      path: "/term",
      name: "TERMS AND DEFINITIONS (ENGLISH-BAHASA MALAYSIA)",
    },
  ];

  const [activeSubItem, setActiveSubItem] = useState(null);

  // const [activeItem, setActiveItem] = useState(null);
  const handleClick = (subItem) => {
    setActiveSubItem(subItem.name);
  };

  return (
    <div>
      <div className="drawer-header">
        <div
          className="drawer-header-logo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <img src={logo} className="drawer-logo" alt="" />
        </div>
        <div className="drawer-header-icon" 
            onClick={() => handleLogout()}>
          <p className="drawer-logout-text">Logout</p>
          <RiLogoutBoxRLine
            className="drawer-icon"
            style={{ marginRight: 30 }}
          />
          <FaBars onClick={toggle} className="drawer-icon" />
        </div>
      </div>

      <div className="drawer-container">
        <div className={openDrawer ? "drawer-open" : "drawer-close"}>
          {/* <div className="drawer-open"> */}
          {/* {openDrawer && ( */}
          <div className="drawer-content">
            <div className="drawer-profile">
              <PiUserCircleThin
                onClick={() => navigate("/user-profile")}
                className="drawer-profile-icon"
              />
              <div className="drawer-profile-text">
                <p className="drawer-welcome">Welcome</p>
                <p className="drawer-name">{user?.fullName.toUpperCase()}</p>
                <p
                  className="drawer-inbox"
                  onClick={() => {
                    navigate("/user/inboxnotif");
                  }}
                >
                  Inbox (0)</p>
                <p
                  className="drawer-inbox"
                  onClick={() => {
                    navigate("/user/bookmark");
                  }}
                >
                  Bookmarks
                </p>
              </div>
            </div>
            {menuItem.map((item, index) => (
              <div key={index}>
                {item.submenu ? (
                  <div
                    className={`drawer-with-submenu ${
                      openMenu === item.name ? "drawer-menu-active" : ""
                    }`}
                    onClick={() => toggleSubMenu(item.name)}
                  >
                    <div className="drawer-with-submenu-text">
                      {item.name}
                      <span>
                        {openMenu === item.name ? (
                          <TbTriangleFilled className="drawer-triangle-icon" />
                        ) : (
                          <TbTriangleInvertedFilled className="drawer-triangle-icon" />
                        )}
                      </span>
                    </div>
                  </div>
                ) : (
                  <NavLink
                    to={item.path}
                    className={({ isActive: linkIsActive }) => {
                      const isActive = activeSubItem === item.name; // Custom active state logic
                      return isActive
                        ? "drawer-menu-active drawer-with-submenu"
                        : "drawer-with-submenu";
                    }}
                    onClick={(e) => {
                      if (item.path === null) {
                        e.preventDefault();
                      }
                      setActiveSubItem(item.name); // Set active item for non-submenu items
                      toggleSubMenu(item.name);
                      handleClick(item);
                    }}
                  >
                    <div className="drawer-menu-text">{item.name}</div>
                  </NavLink>
                )}

                {item.submenu && openMenu === item.name && (
                  <div className="drawer-submenu">
                    {item.submenu.map((subItem, subIndex) => {
                      const isActive = activeSubItem === subItem.name;

                      return (
                        <NavLink
                          to={
                            subItem.path
                              ? subItem.path
                              : subItem.id
                              ? `/resource-centre/${subItem.id}`
                              : "#"
                          }
                          key={subIndex}
                          className={
                            isActive
                              ? "drawer-submenu-active"
                              : "drawer-submenu-inactive"
                          }
                          onClick={(e) => {
                            if (subItem.path === null) {
                              e.preventDefault();
                            }
                            handleClick(subItem);
                          }}
                        >
                          <div className="drawer-submenu-text">
                            {subItem.name}
                          </div>
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div style={{ height: "30px" }}></div>
        </div>
        <main className="drawer-page-content">
          {showBanner && <Banner />}
          {children}
        </main>
      </div>
      <div style={{ height: "30px" }}></div>
      <Footer openDialog={openDialog} setOpenDialog={setOpenDialog} />
    </div>
  );
};

export default DrawerNavigator;
